"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
var ark_request_1 = require("@tencent/ark-request");
var util_1 = require("../util");
var base_channel_interface_1 = require("../channel/base-channel/base-channel.interface");
var base_1 = require("../base");
var request_backoff_1 = require("./request-backoff");
var networkRequest = ark_request_1.createNetworkRequestInstance();
/**
 * 需要重试的异常：
 * 1. 需求代码
 * @param error 异常信息
 * @returns 需要重试返回 true，不需要重试返回 false
 */
var errorFilter = function (error) {
    var _a, _b;
    var code = (_a = error.code) !== null && _a !== void 0 ? _a : '';
    // 1. 断网 or 请求超时 需要重试
    if ([ark_request_1.REQUEST_ERROR_CODE.network, ark_request_1.REQUEST_ERROR_CODE.timeout].includes(code)) {
        return true;
    }
    // 2. 非 200 的状态码也需要重试
    if (((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) !== 200) {
        return true;
    }
    // 3. 其他异常暂时不进行重试，直接透传抛出异常
    return false;
};
var Request = /** @class */ (function () {
    function Request() {
    }
    /**
     * 发送请求，内部有重试逻辑
     *
     * @param {string} requestUrl
     * @param {Method} [method=Method.POST]
     * @param {any} [body]
     * @returns
     */
    Request.prototype.sendRequest = function (requestUrl, method, body, requestConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var response, backoffFactory, newRequestConfig, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        response = void 0;
                        backoffFactory = new request_backoff_1.RequestBackOff();
                        newRequestConfig = __assign(__assign({}, requestConfig), { errorFilter: errorFilter, backoffFactory: backoffFactory });
                        if (!(method === base_channel_interface_1.Method.GET)) return [3 /*break*/, 2];
                        return [4 /*yield*/, networkRequest.get(requestUrl, newRequestConfig)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, networkRequest.post(requestUrl, body, newRequestConfig)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, new base_1.Result(undefined, response)];
                    case 5:
                        error_1 = _a.sent();
                        // 以下情况会走到异常分支：
                        // 1. 网络异常：网络断开，网络超时，请求取消等；
                        // 2. 网络请求响应码不为 2xx；
                        // 3. 其他的代码执行异常；
                        util_1.ConnectionLog.error("Request Failed, url:" + requestUrl + ", stack: " + (error_1 === null || error_1 === void 0 ? void 0 : error_1.stack) + ", message: " + (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) + ", code: " + (error_1 === null || error_1 === void 0 ? void 0 : error_1.code));
                        return [2 /*return*/, new base_1.Result(error_1)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 将请求放入网络传输队列
     * @return { boolean } 是否成功放入请求队列
     */
    Request.prototype.sendBeacon = function (url, data, contentType) {
        try {
            var type = contentType !== null && contentType !== void 0 ? contentType : base_1.ContentTypeValue.JSON;
            var blob = new Blob([util_1.JsonUtil.jsonStringify(data)], { type: type });
            return navigator.sendBeacon(url, blob);
        }
        catch (error) {
            util_1.ConnectionLog.error("sendBeacon Failed, url:" + url + ", stack: " + (error === null || error === void 0 ? void 0 : error.stack) + ", message: " + (error === null || error === void 0 ? void 0 : error.message) + ", code: " + (error === null || error === void 0 ? void 0 : error.code));
            return false;
        }
    };
    return Request;
}());
exports.Request = Request;
